export interface ColorScheme {
  'token-text-main-primary': string;
  'token-text-main-secondary': string;
  'token-text-main-tertiary': string;
  'token-text-main-disabled': string;
  'token-text-main-tertiary-inverse': string;
  'token-text-main-primary-inverse': string;

  'token-text-brand-primary-hover': string;
  'token-text-brand-primary': string;
  'token-text-brand-secondary': string;
  'token-text-brand-primary-inverse': string;

  'token-text-badge-green': string;
  'token-text-badge-amber': string;
  'token-text-badge-blue': string;

  'token-text-negative-red': string;

  'token-surface-primary-bw-09': string;
  'token-surface-primary-bw-08': string;
  'token-surface-primary-bw-07': string;
  'token-surface-primary-bw-06': string;
  'token-surface-primary-bw-05': string;
  'token-surface-primary-bw-04': string;
  'token-surface-primary-bw-03': string;
  'token-surface-primary-bw-25': string;
  'token-surface-primary-bw-02': string;
  'token-surface-primary-bw-01': string;
  'token-surface-primary-bw-00': string;

  'token-surface-brand-static-lili': string;
  'token-surface-brand-action-05': string;
  'token-surface-brand-action-04': string;
  'token-surface-brand-action-03': string;
  'token-surface-brand-action-02': string;
  'token-surface-brand-action-01': string;
  'token-surface-brand-action-00': string;

  'token-surface-negative-primary': string;
  'token-surface-negative-primary-hover': string;
  'token-surface-negative-secondary': string;
  'token-surface-negative-tertiary': string;

  'token-surface-badge-orange': string;
  'token-surface-badge-red': string;
  'token-surface-badge-green': string;
  'token-surface-badge-amber': string;
  'token-surface-badge-blue-02': string;
  'token-surface-badge-blue-00': string;

  'token-surface-purple-primary': string;
  'token-surface-purple-secondary': string;

  'token-surface-yellow-primary': string;

  'token-surface-orange-primary': string;
  'token-surface-orange-secondary': string;
  'token-surface-orange-tertiary': string;

  'token-surface-green-primary': string;

  'token-outline-primary-bw-09': string;
  'token-outline-primary-bw-08': string;
  'token-outline-primary-bw-07': string;
  'token-outline-primary-bw-06': string;
  'token-outline-primary-bw-05': string;
  'token-outline-primary-bw-04': string;
  'token-outline-primary-bw-03': string;
  'token-outline-primary-bw-02': string;
  'token-outline-primary-bw-01': string;
  'token-outline-primary-bw-00': string;

  'token-outline-brand-primary': string;
  'token-outline-brand-secondary': string;
  'token-outline-brand-tertiary': string;
  'token-outline-brand-primary-inverse': string;

  'token-outline-amber-primary': string;

  'token-outline-purple-primary': string;
  'token-outline-purple-secondary': string;

  'token-outline-positive-primary': string;
  'token-outline-positive-secondary': string;

  'token-outline-negative-primary': string;

  'token-outline-orange-primary': string;

  'token-transparent': string;
}

export const liliColorScheme: ColorScheme = {
  'token-text-main-primary': '#20242E',
  'token-text-main-secondary': '#525D71',
  'token-text-main-tertiary': '#7C8593',
  'token-text-main-disabled': '#A8B2C8',
  'token-text-main-tertiary-inverse': '#C4CBDC',
  'token-text-main-primary-inverse': '#FFFFFF',

  'token-text-brand-primary-hover': '#0042C4',
  'token-text-brand-primary': '#0E5CF4',
  'token-text-brand-secondary': '#75BDFF',
  'token-text-brand-primary-inverse': '#F2F8FF',

  'token-text-badge-green': '#00995C',
  'token-text-badge-amber': '#C08C17',
  'token-text-badge-blue': '#008FDB',

  'token-text-negative-red': '#E74343',

  'token-surface-primary-bw-09': '#13151A',
  'token-surface-primary-bw-08': '#20242E',
  'token-surface-primary-bw-07': '#525D71',
  'token-surface-primary-bw-06': '#7C8593',
  'token-surface-primary-bw-05': '#A8B2C8',
  'token-surface-primary-bw-04': '#C4CBDC',
  'token-surface-primary-bw-03': '#DFE2EB',
  'token-surface-primary-bw-25': '#EDEFF4',
  'token-surface-primary-bw-02': '#F6F7FA',
  'token-surface-primary-bw-01': '#FBFBFD',
  'token-surface-primary-bw-00': '#FFFFFF',

  'token-surface-brand-static-lili': '#00193C',
  'token-surface-brand-action-05': '#00193C',
  'token-surface-brand-action-04': '#0042C4',
  'token-surface-brand-action-03': '#0E5CF4',
  'token-surface-brand-action-02': '#75BDFF',
  'token-surface-brand-action-01': '#C5E3FF',
  'token-surface-brand-action-00': '#F2F8FF',

  'token-surface-negative-primary': '#E74343',
  'token-surface-negative-primary-hover': '#B70000',
  'token-surface-negative-secondary': '#FFE6E6',
  'token-surface-negative-tertiary': '#FCF6F6',

  'token-surface-badge-orange': '#FDEACC',
  'token-surface-badge-red': '#FCF6F6',
  'token-surface-badge-green': '#E0F6ED',
  'token-surface-badge-amber': '#FEF8ED',
  'token-surface-badge-blue-02': '#008FDB',
  'token-surface-badge-blue-00': '#E7F4FE',

  'token-surface-purple-primary': '#D0D9F9',
  'token-surface-purple-secondary': '#EEF2FF',

  'token-surface-yellow-primary': '#FDD835',

  'token-surface-orange-primary': '#D34E15',
  'token-surface-orange-secondary': '#DD7200',
  'token-surface-orange-tertiary': '#FCBD8F',

  'token-surface-green-primary': '#44CA38',

  'token-outline-primary-bw-09': '#13151A',
  'token-outline-primary-bw-08': '#20242E',
  'token-outline-primary-bw-07': '#525D71',
  'token-outline-primary-bw-06': '#7C8593',
  'token-outline-primary-bw-05': '#A8B2C8',
  'token-outline-primary-bw-04': '#C4CBDC',
  'token-outline-primary-bw-03': '#DFE2EB',
  'token-outline-primary-bw-02': '#F6F7FA',
  'token-outline-primary-bw-01': '#FBFBFD',
  'token-outline-primary-bw-00': '#FFFFFF',

  'token-outline-brand-primary': '#0E5CF4',
  'token-outline-brand-secondary': '#75BDFF',
  'token-outline-brand-tertiary': '#C5E3FF',
  'token-outline-brand-primary-inverse': '#F2F8FF',

  'token-outline-amber-primary': '#C08C17',

  'token-outline-purple-primary': '#D0D9F9',
  'token-outline-purple-secondary': '#EEF2FF',

  'token-outline-positive-primary': '#00995C',
  'token-outline-positive-secondary': '#E0F6ED',

  'token-outline-negative-primary': '#E74343',

  'token-outline-orange-primary': '#DD7200',

  'token-transparent': 'transparent',
};

export const dunAndBradstreetColorScheme: ColorScheme = {
  'token-text-main-primary': '#161919',
  'token-text-main-secondary': '#868686',
  'token-text-main-tertiary': '#868686',
  'token-text-main-disabled': '#A8B2C8',
  'token-text-main-tertiary-inverse': '#C4CBDC',
  'token-text-main-primary-inverse': '#FFFFFF',

  'token-text-brand-primary-hover': '#3095B4',
  'token-text-brand-primary': '#0078A7',
  'token-text-brand-secondary': '#3095B4',
  'token-text-brand-primary-inverse': '#F1F6F8',

  'token-text-badge-green': '#00995C',
  'token-text-badge-amber': '#C08C17',
  'token-text-badge-blue': '#008FDB',

  'token-text-negative-red': '#E74343',

  'token-surface-primary-bw-09': '#13151A',
  'token-surface-primary-bw-08': '#20242E',
  'token-surface-primary-bw-07': '#525D71',
  'token-surface-primary-bw-06': '#7C8593',
  'token-surface-primary-bw-05': '#A8B2C8',
  'token-surface-primary-bw-04': '#C4CBDC',
  'token-surface-primary-bw-03': '#DFE2EB',
  'token-surface-primary-bw-25': '#EDEFF4',
  'token-surface-primary-bw-02': '#F7F7F7',
  'token-surface-primary-bw-01': '#FBFBFD',
  'token-surface-primary-bw-00': '#FFFFFF',

  'token-surface-brand-static-lili': '#00193C',
  'token-surface-brand-action-05': '#101820',
  'token-surface-brand-action-04': '#3095B4',
  'token-surface-brand-action-03': '#0078A7',
  'token-surface-brand-action-02': '#3095B4',
  'token-surface-brand-action-01': '#3095B43D',
  'token-surface-brand-action-00': '#F1F6F8',

  'token-surface-negative-primary': '#E74343',
  'token-surface-negative-primary-hover': '#B70000',
  'token-surface-negative-secondary': '#FFE6E6',
  'token-surface-negative-tertiary': '#FCF6F6',

  'token-surface-badge-orange': '#FDEACC',
  'token-surface-badge-red': '#FCF6F6',
  'token-surface-badge-green': '#E0F6ED',
  'token-surface-badge-amber': '#FEF8ED',
  'token-surface-badge-blue-02': '#008FDB',
  'token-surface-badge-blue-00': '#E7F4FE',

  'token-surface-purple-primary': '#D0D9F9',
  'token-surface-purple-secondary': '#EEF2FF',

  'token-surface-yellow-primary': '#FDD835',

  'token-surface-orange-primary': '#D34E15',
  'token-surface-orange-secondary': '#DD7200',
  'token-surface-orange-tertiary': '#FCBD8F',

  'token-surface-green-primary': '#44CA38',

  'token-outline-primary-bw-09': '#13151A',
  'token-outline-primary-bw-08': '#20242E',
  'token-outline-primary-bw-07': '#525D71',
  'token-outline-primary-bw-06': '#7C8593',
  'token-outline-primary-bw-05': '#A8B2C8',
  'token-outline-primary-bw-04': '#C4CBDC',
  'token-outline-primary-bw-03': '#DFE2EB',
  'token-outline-primary-bw-02': '#F6F7FA',
  'token-outline-primary-bw-01': '#FBFBFD',
  'token-outline-primary-bw-00': '#FFFFFF',

  'token-outline-brand-primary': '#0078A7',
  'token-outline-brand-secondary': '#3095B4',
  'token-outline-brand-tertiary': '#3095B43D',
  'token-outline-brand-primary-inverse': '#F1F6F8',

  'token-outline-amber-primary': '#C08C17',

  'token-outline-purple-primary': '#D0D9F9',
  'token-outline-purple-secondary': '#EEF2FF',

  'token-outline-positive-primary': '#00995C',
  'token-outline-positive-secondary': '#E0F6ED',

  'token-outline-negative-primary': '#E74343',

  'token-outline-orange-primary': '#DD7200',

  'token-transparent': 'transparent',
};

export const wyomingColorScheme: ColorScheme = {
  'token-text-main-primary': '#101119',
  'token-text-main-secondary': '#373E4D',
  'token-text-main-tertiary': '#4E5766',
  'token-text-main-disabled': '#A8B2C8',
  'token-text-main-tertiary-inverse': '#C4CBDC',
  'token-text-main-primary-inverse': '#FFFFFF',

  'token-text-brand-primary-hover': '#9CC6E2',
  'token-text-brand-primary': '#306BAC',
  'token-text-brand-secondary': '#306BAC4D',
  'token-text-brand-primary-inverse': '#E4F2FA',

  'token-text-badge-green': '#1F7A2F',
  'token-text-badge-amber': '#9B5C00',
  'token-text-badge-blue': '#1A6979',

  'token-text-negative-red': '#DA2E16',

  'token-surface-primary-bw-09': '#13151A',
  'token-surface-primary-bw-08': '#101119',
  'token-surface-primary-bw-07': '#525D71',
  'token-surface-primary-bw-06': '#525D71',
  'token-surface-primary-bw-05': '#10111933',
  'token-surface-primary-bw-04': '#10111933',
  'token-surface-primary-bw-03': '#1011191F',
  'token-surface-primary-bw-25': '#EDEFF4',
  'token-surface-primary-bw-02': '#F6F7F9',
  'token-surface-primary-bw-01': '#F6F7F9',
  'token-surface-primary-bw-00': '#FFFFFF',

  'token-surface-brand-static-lili': '#00193C',
  'token-surface-brand-action-05': '#101820',
  'token-surface-brand-action-04': '#9CC6E2',
  'token-surface-brand-action-03': '#306BAC',
  'token-surface-brand-action-02': '#306BAC4D',
  'token-surface-brand-action-01': '#306BAC14',
  'token-surface-brand-action-00': '#E4F2FA',

  'token-surface-negative-primary': '#DA2E16',
  'token-surface-negative-primary-hover': '#B70000',
  'token-surface-negative-secondary': '#DA2E164D',
  'token-surface-negative-tertiary': '#DA2E1614',

  'token-surface-badge-orange': '#FDEACC',
  'token-surface-badge-red': '#DA2E1614',
  'token-surface-badge-green': '#E9F3E1',
  'token-surface-badge-amber': '#9B5C0014',
  'token-surface-badge-blue-02': '#1A6979',
  'token-surface-badge-blue-00': '#D9EFEF',

  'token-surface-purple-primary': '#DDD9F9',
  'token-surface-purple-secondary': '#EEF2FF',

  'token-surface-yellow-primary': '#FDD835',

  'token-surface-orange-primary': '#D34E15',
  'token-surface-orange-secondary': '#DD7200',
  'token-surface-orange-tertiary': '#FCBD8F',

  'token-surface-green-primary': '#1F7A2F',

  'token-outline-primary-bw-09': '#13151A',
  'token-outline-primary-bw-08': '#101119',
  'token-outline-primary-bw-07': '#525D71',
  'token-outline-primary-bw-06': '#4E5766',
  'token-outline-primary-bw-05': '#10111914',
  'token-outline-primary-bw-04': '#10111933',
  'token-outline-primary-bw-03': '#1011191F',
  'token-outline-primary-bw-02': '#EDF0F2',
  'token-outline-primary-bw-01': '#F6F7F9',
  'token-outline-primary-bw-00': '#FFFFFF',

  'token-outline-brand-primary': '#306BAC',
  'token-outline-brand-secondary': '#306BAC4D',
  'token-outline-brand-tertiary': '#306BAC14',
  'token-outline-brand-primary-inverse': '#E4F2FA',

  'token-outline-amber-primary': '#9B5C00',

  'token-outline-purple-primary': '#DDD9F9',
  'token-outline-purple-secondary': '#EEF2FF',

  'token-outline-positive-primary': '#1F7A2F',
  'token-outline-positive-secondary': '#E9F3E1',

  'token-outline-negative-primary': '#DA2E16',

  'token-outline-orange-primary': '#DD7200',

  'token-transparent': 'transparent',
};

export const testPartnerColorScheme: ColorScheme = {
  'token-text-main-primary': '#20242E',
  'token-text-main-secondary': '#525D71',
  'token-text-main-tertiary': '#7C8593',
  'token-text-main-disabled': '#A8B2C8',
  'token-text-main-tertiary-inverse': '#C4CBDC',
  'token-text-main-primary-inverse': '#FFFFFF',

  'token-text-brand-primary-hover': '#4C1D95',
  'token-text-brand-primary': '#6B21A8',
  'token-text-brand-secondary': '#A78BFA',
  'token-text-brand-primary-inverse': '#F8F5FF',

  'token-text-badge-green': '#00995C',
  'token-text-badge-amber': '#C08C17',
  'token-text-badge-blue': '#A78BFA',

  'token-text-negative-red': '#E74343',

  'token-surface-primary-bw-09': '#13151A',
  'token-surface-primary-bw-08': '#20242E',
  'token-surface-primary-bw-07': '#525D71',
  'token-surface-primary-bw-06': '#7C8593',
  'token-surface-primary-bw-05': '#A8B2C8',
  'token-surface-primary-bw-04': '#C4CBDC',
  'token-surface-primary-bw-03': '#DFE2EB',
  'token-surface-primary-bw-25': '#EDEFF4',
  'token-surface-primary-bw-02': '#F6F7FA',
  'token-surface-primary-bw-01': '#FBFBFD',
  'token-surface-primary-bw-00': '#FFFFFF',

  'token-surface-brand-static-lili': '#00193C',
  'token-surface-brand-action-05': '#2E0854',
  'token-surface-brand-action-04': '#4C1D95',
  'token-surface-brand-action-03': '#6B21A8',
  'token-surface-brand-action-02': '#A78BFA',
  'token-surface-brand-action-01': '#DDD6FE',
  'token-surface-brand-action-00': '#F8F5FF',

  'token-surface-negative-primary': '#E74343',
  'token-surface-negative-primary-hover': '#B70000',
  'token-surface-negative-secondary': '#FFE6E6',
  'token-surface-negative-tertiary': '#FCF6F6',

  'token-surface-badge-orange': '#FDEACC',
  'token-surface-badge-red': '#FCF6F6',
  'token-surface-badge-green': '#E0F6ED',
  'token-surface-badge-amber': '#FEF8ED',
  'token-surface-badge-blue-02': '#A78BFA',
  'token-surface-badge-blue-00': '#F5F3FF',

  'token-surface-purple-primary': '#D0D9F9',
  'token-surface-purple-secondary': '#EEF2FF',

  'token-surface-yellow-primary': '#FDD835',

  'token-surface-orange-primary': '#D34E15',
  'token-surface-orange-secondary': '#DD7200',
  'token-surface-orange-tertiary': '#FCBD8F',

  'token-surface-green-primary': '#44CA38',

  'token-outline-primary-bw-09': '#13151A',
  'token-outline-primary-bw-08': '#20242E',
  'token-outline-primary-bw-07': '#525D71',
  'token-outline-primary-bw-06': '#7C8593',
  'token-outline-primary-bw-05': '#A8B2C8',
  'token-outline-primary-bw-04': '#C4CBDC',
  'token-outline-primary-bw-03': '#DFE2EB',
  'token-outline-primary-bw-02': '#F6F7FA',
  'token-outline-primary-bw-01': '#FBFBFD',
  'token-outline-primary-bw-00': '#FFFFFF',

  'token-outline-brand-primary': '#6B21A8',
  'token-outline-brand-secondary': '#A78BFA',
  'token-outline-brand-tertiary': '#DDD6FE',
  'token-outline-brand-primary-inverse': '#F8F5FF',

  'token-outline-amber-primary': '#C08C17',

  'token-outline-purple-primary': '#D0D9F9',
  'token-outline-purple-secondary': '#EEF2FF',

  'token-outline-positive-primary': '#00995C',
  'token-outline-positive-secondary': '#E0F6ED',

  'token-outline-negative-primary': '#E74343',

  'token-outline-orange-primary': '#DD7200',

  'token-transparent': 'transparent',
};

export const testPartnerColorScheme2: ColorScheme = {
  'token-text-main-primary': '#20242E',
  'token-text-main-secondary': '#525D71',
  'token-text-main-tertiary': '#7C8593',
  'token-text-main-disabled': '#A8B2C8',
  'token-text-main-tertiary-inverse': '#C4CBDC',
  'token-text-main-primary-inverse': '#FFFFFF',

  'token-text-brand-primary-hover': '#1A1A1A',
  'token-text-brand-primary': '#2A2A2A',
  'token-text-brand-secondary': '#A0A0A0',
  'token-text-brand-primary-inverse': '#FAFAFA',

  'token-text-badge-green': '#00995C',
  'token-text-badge-amber': '#C08C17',
  'token-text-badge-blue': '#A78BFA',
  'token-text-negative-red': '#E74343',

  'token-surface-primary-bw-09': '#13151A',
  'token-surface-primary-bw-08': '#20242E',
  'token-surface-primary-bw-07': '#525D71',
  'token-surface-primary-bw-06': '#7C8593',
  'token-surface-primary-bw-05': '#A8B2C8',
  'token-surface-primary-bw-04': '#C4CBDC',
  'token-surface-primary-bw-03': '#DFE2EB',
  'token-surface-primary-bw-25': '#EDEFF4',
  'token-surface-primary-bw-02': '#F6F7FA',
  'token-surface-primary-bw-01': '#FBFBFD',
  'token-surface-primary-bw-00': '#FFFFFF',

  'token-surface-brand-static-lili': '#00193C',
  'token-surface-brand-action-05': '#0A0A0A',
  'token-surface-brand-action-04': '#1A1A1A',
  'token-surface-brand-action-03': '#2A2A2A',
  'token-surface-brand-action-02': '#A0A0A0',
  'token-surface-brand-action-01': '#E0E0E0',
  'token-surface-brand-action-00': '#F9F9F9',

  'token-surface-negative-primary': '#E74343',
  'token-surface-negative-primary-hover': '#B70000',
  'token-surface-negative-secondary': '#FFE6E6',
  'token-surface-negative-tertiary': '#FCF6F6',
  'token-surface-badge-orange': '#FDEACC',
  'token-surface-badge-red': '#FCF6F6',
  'token-surface-badge-green': '#E0F6ED',
  'token-surface-badge-amber': '#FEF8ED',
  'token-surface-badge-blue-02': '#A78BFA',
  'token-surface-badge-blue-00': '#F5F3FF',
  'token-surface-purple-primary': '#D0D9F9',
  'token-surface-purple-secondary': '#EEF2FF',
  'token-surface-yellow-primary': '#FDD835',
  'token-surface-orange-primary': '#D34E15',
  'token-surface-orange-secondary': '#DD7200',
  'token-surface-orange-tertiary': '#FCBD8F',
  'token-surface-green-primary': '#44CA38',

  'token-outline-primary-bw-09': '#13151A',
  'token-outline-primary-bw-08': '#20242E',
  'token-outline-primary-bw-07': '#525D71',
  'token-outline-primary-bw-06': '#7C8593',
  'token-outline-primary-bw-05': '#A8B2C8',
  'token-outline-primary-bw-04': '#C4CBDC',
  'token-outline-primary-bw-03': '#DFE2EB',
  'token-outline-primary-bw-02': '#F6F7FA',
  'token-outline-primary-bw-01': '#FBFBFD',
  'token-outline-primary-bw-00': '#FFFFFF',

  'token-outline-brand-primary': '#2A2A2A',
  'token-outline-brand-secondary': '#A0A0A0',
  'token-outline-brand-tertiary': '#E0E0E0',
  'token-outline-brand-primary-inverse': '#F9F9F9',

  'token-outline-amber-primary': '#C08C17',
  'token-outline-purple-primary': '#D0D9F9',
  'token-outline-purple-secondary': '#EEF2FF',
  'token-outline-positive-primary': '#00995C',
  'token-outline-positive-secondary': '#E0F6ED',
  'token-outline-negative-primary': '#E74343',
  'token-outline-orange-primary': '#DD7200',

  'token-transparent': 'transparent',
};

export const testPartnerColorScheme3: ColorScheme = {
  'token-text-main-primary': '#20242E',
  'token-text-main-secondary': '#525D71',
  'token-text-main-tertiary': '#7C8593',
  'token-text-main-disabled': '#A8B2C8',
  'token-text-main-tertiary-inverse': '#C4CBDC',
  'token-text-main-primary-inverse': '#FFFFFF',

  'token-text-brand-primary-hover': '#014D40',
  'token-text-brand-primary': '#016E5F',
  'token-text-brand-secondary': '#6FC1B8',
  'token-text-brand-primary-inverse': '#ECF5F3',

  'token-text-badge-green': '#00995C',
  'token-text-badge-amber': '#C08C17',
  'token-text-badge-blue': '#A78BFA',
  'token-text-negative-red': '#E74343',

  'token-surface-primary-bw-09': '#13151A',
  'token-surface-primary-bw-08': '#20242E',
  'token-surface-primary-bw-07': '#525D71',
  'token-surface-primary-bw-06': '#7C8593',
  'token-surface-primary-bw-05': '#A8B2C8',
  'token-surface-primary-bw-04': '#C4CBDC',
  'token-surface-primary-bw-03': '#DFE2EB',
  'token-surface-primary-bw-25': '#EDEFF4',
  'token-surface-primary-bw-02': '#F6F7FA',
  'token-surface-primary-bw-01': '#FBFBFD',
  'token-surface-primary-bw-00': '#FFFFFF',

  'token-surface-brand-static-lili': '#00193C',
  'token-surface-brand-action-05': '#012E28',
  'token-surface-brand-action-04': '#014D40',
  'token-surface-brand-action-03': '#016E5F',
  'token-surface-brand-action-02': '#6FC1B8',
  'token-surface-brand-action-01': '#CDE9E6',
  'token-surface-brand-action-00': '#ECF5F3',

  'token-surface-negative-primary': '#E74343',
  'token-surface-negative-primary-hover': '#B70000',
  'token-surface-negative-secondary': '#FFE6E6',
  'token-surface-negative-tertiary': '#FCF6F6',
  'token-surface-badge-orange': '#FDEACC',
  'token-surface-badge-red': '#FCF6F6',
  'token-surface-badge-green': '#E0F6ED',
  'token-surface-badge-amber': '#FEF8ED',
  'token-surface-badge-blue-02': '#A78BFA',
  'token-surface-badge-blue-00': '#F5F3FF',
  'token-surface-purple-primary': '#D0D9F9',
  'token-surface-purple-secondary': '#EEF2FF',
  'token-surface-yellow-primary': '#FDD835',
  'token-surface-orange-primary': '#D34E15',
  'token-surface-orange-secondary': '#DD7200',
  'token-surface-orange-tertiary': '#FCBD8F',
  'token-surface-green-primary': '#44CA38',

  'token-outline-primary-bw-09': '#13151A',
  'token-outline-primary-bw-08': '#20242E',
  'token-outline-primary-bw-07': '#525D71',
  'token-outline-primary-bw-06': '#7C8593',
  'token-outline-primary-bw-05': '#A8B2C8',
  'token-outline-primary-bw-04': '#C4CBDC',
  'token-outline-primary-bw-03': '#DFE2EB',
  'token-outline-primary-bw-02': '#F6F7FA',
  'token-outline-primary-bw-01': '#FBFBFD',
  'token-outline-primary-bw-00': '#FFFFFF',

  'token-outline-brand-primary': '#016E5F',
  'token-outline-brand-secondary': '#6FC1B8',
  'token-outline-brand-tertiary': '#CDE9E6',
  'token-outline-brand-primary-inverse': '#ECF5F3',

  'token-outline-amber-primary': '#C08C17',
  'token-outline-purple-primary': '#D0D9F9',
  'token-outline-purple-secondary': '#EEF2FF',
  'token-outline-positive-primary': '#00995C',
  'token-outline-positive-secondary': '#E0F6ED',
  'token-outline-negative-primary': '#E74343',
  'token-outline-orange-primary': '#DD7200',

  'token-transparent': 'transparent',
};

export const testPartnerColorScheme4: ColorScheme = {
  'token-text-main-primary': '#20242E',
  'token-text-main-secondary': '#525D71',
  'token-text-main-tertiary': '#7C8593',
  'token-text-main-disabled': '#A8B2C8',
  'token-text-main-tertiary-inverse': '#C4CBDC',
  'token-text-main-primary-inverse': '#FFFFFF',

  'token-text-brand-primary-hover': '#045D75',
  'token-text-brand-primary': '#06AED5',
  'token-text-brand-secondary': '#9CEAEF',
  'token-text-brand-primary-inverse': '#E5FBFF',

  'token-text-badge-green': '#00995C',
  'token-text-badge-amber': '#C08C17',
  'token-text-badge-blue': '#A78BFA',
  'token-text-negative-red': '#E74343',

  'token-surface-primary-bw-09': '#13151A',
  'token-surface-primary-bw-08': '#20242E',
  'token-surface-primary-bw-07': '#525D71',
  'token-surface-primary-bw-06': '#7C8593',
  'token-surface-primary-bw-05': '#A8B2C8',
  'token-surface-primary-bw-04': '#C4CBDC',
  'token-surface-primary-bw-03': '#DFE2EB',
  'token-surface-primary-bw-25': '#EDEFF4',
  'token-surface-primary-bw-02': '#F6F7FA',
  'token-surface-primary-bw-01': '#FBFBFD',
  'token-surface-primary-bw-00': '#FFFFFF',

  'token-surface-brand-static-lili': '#00193C',
  'token-surface-brand-action-05': '#02313E',
  'token-surface-brand-action-04': '#045D75',
  'token-surface-brand-action-03': '#06AED5',
  'token-surface-brand-action-02': '#9CEAEF',
  'token-surface-brand-action-01': '#D3F9FD',
  'token-surface-brand-action-00': '#E5FBFF',

  'token-surface-negative-primary': '#E74343',
  'token-surface-negative-primary-hover': '#B70000',
  'token-surface-negative-secondary': '#FFE6E6',
  'token-surface-negative-tertiary': '#FCF6F6',
  'token-surface-badge-orange': '#FDEACC',
  'token-surface-badge-red': '#FCF6F6',
  'token-surface-badge-green': '#E0F6ED',
  'token-surface-badge-amber': '#FEF8ED',
  'token-surface-badge-blue-02': '#A78BFA',
  'token-surface-badge-blue-00': '#F5F3FF',
  'token-surface-purple-primary': '#D0D9F9',
  'token-surface-purple-secondary': '#EEF2FF',
  'token-surface-yellow-primary': '#FDD835',
  'token-surface-orange-primary': '#D34E15',
  'token-surface-orange-secondary': '#DD7200',
  'token-surface-orange-tertiary': '#FCBD8F',
  'token-surface-green-primary': '#44CA38',

  'token-outline-primary-bw-09': '#13151A',
  'token-outline-primary-bw-08': '#20242E',
  'token-outline-primary-bw-07': '#525D71',
  'token-outline-primary-bw-06': '#7C8593',
  'token-outline-primary-bw-05': '#A8B2C8',
  'token-outline-primary-bw-04': '#C4CBDC',
  'token-outline-primary-bw-03': '#DFE2EB',
  'token-outline-primary-bw-02': '#F6F7FA',
  'token-outline-primary-bw-01': '#FBFBFD',
  'token-outline-primary-bw-00': '#FFFFFF',

  'token-outline-brand-primary': '#06AED5',
  'token-outline-brand-secondary': '#9CEAEF',
  'token-outline-brand-tertiary': '#D3F9FD',
  'token-outline-brand-primary-inverse': '#E5FBFF',

  'token-outline-amber-primary': '#C08C17',
  'token-outline-purple-primary': '#D0D9F9',
  'token-outline-purple-secondary': '#EEF2FF',
  'token-outline-positive-primary': '#00995C',
  'token-outline-positive-secondary': '#E0F6ED',
  'token-outline-negative-primary': '#E74343',
  'token-outline-orange-primary': '#DD7200',

  'token-transparent': 'transparent',
};

export const eighteenHundredAccountantsColorScheme: ColorScheme = {
  'token-text-main-primary': '#20242E',
  'token-text-main-secondary': '#525D71',
  'token-text-main-tertiary': '#7C8593',
  'token-text-main-disabled': '#A8B2C8',
  'token-text-main-tertiary-inverse': '#C4CBDC',
  'token-text-main-primary-inverse': '#FFFFFF',

  'token-text-brand-primary-hover': '#2B7D74',
  'token-text-brand-primary': '#2DA38D',
  'token-text-brand-secondary': '#DBF6E7',
  'token-text-brand-primary-inverse': '#F2F8FF',

  'token-text-badge-green': '#00995C',
  'token-text-badge-amber': '#C08C17',
  'token-text-badge-blue': '#008FDB',

  'token-text-negative-red': '#E74343',

  'token-surface-primary-bw-09': '#13151A',
  'token-surface-primary-bw-08': '#20242E',
  'token-surface-primary-bw-07': '#525D71',
  'token-surface-primary-bw-06': '#7C8593',
  'token-surface-primary-bw-05': '#A8B2C8',
  'token-surface-primary-bw-04': '#C4CBDC',
  'token-surface-primary-bw-03': '#DFE2EB',
  'token-surface-primary-bw-25': '#EDEFF4',
  'token-surface-primary-bw-02': '#F6F7FA',
  'token-surface-primary-bw-01': '#FBFBFD',
  'token-surface-primary-bw-00': '#FFFFFF',

  'token-surface-brand-static-lili': '#2B7D74',
  'token-surface-brand-action-05': '#2B7D74',
  'token-surface-brand-action-04': '#2B7D74',
  'token-surface-brand-action-03': '#2DA38D',
  'token-surface-brand-action-02': '#75BDFF',
  'token-surface-brand-action-01': '#C5E3FF',
  'token-surface-brand-action-00': '#F2F8FF',

  'token-surface-negative-primary': '#E74343',
  'token-surface-negative-primary-hover': '#B70000',
  'token-surface-negative-secondary': '#FFE6E6',
  'token-surface-negative-tertiary': '#FCF6F6',

  'token-surface-badge-orange': '#FDEACC',
  'token-surface-badge-red': '#FCF6F6',
  'token-surface-badge-green': '#E0F6ED',
  'token-surface-badge-amber': '#FEF8ED',
  'token-surface-badge-blue-02': '#008FDB',
  'token-surface-badge-blue-00': '#E7F4FE',

  'token-surface-purple-primary': '#D0D9F9',
  'token-surface-purple-secondary': '#EEF2FF',

  'token-surface-yellow-primary': '#FDD835',

  'token-surface-orange-primary': '#D34E15',
  'token-surface-orange-secondary': '#DD7200',
  'token-surface-orange-tertiary': '#FCBD8F',

  'token-surface-green-primary': '#44CA38',

  'token-outline-primary-bw-09': '#13151A',
  'token-outline-primary-bw-08': '#20242E',
  'token-outline-primary-bw-07': '#525D71',
  'token-outline-primary-bw-06': '#7C8593',
  'token-outline-primary-bw-05': '#A8B2C8',
  'token-outline-primary-bw-04': '#C4CBDC',
  'token-outline-primary-bw-03': '#DFE2EB',
  'token-outline-primary-bw-02': '#F6F7FA',
  'token-outline-primary-bw-01': '#FBFBFD',
  'token-outline-primary-bw-00': '#FFFFFF',

  'token-outline-brand-primary': '#2B7D74',
  'token-outline-brand-secondary': '#2DA38D',
  'token-outline-brand-tertiary': '#C5E3FF',
  'token-outline-brand-primary-inverse': '#F2F8FF',

  'token-outline-amber-primary': '#C08C17',

  'token-outline-purple-primary': '#D0D9F9',
  'token-outline-purple-secondary': '#EEF2FF',

  'token-outline-positive-primary': '#00995C',
  'token-outline-positive-secondary': '#E0F6ED',

  'token-outline-negative-primary': '#E74343',

  'token-outline-orange-primary': '#DD7200',

  'token-transparent': 'transparent',
};

export const applyColorScheme = (colorScheme: ColorScheme) => {
  const root = document.documentElement;
  Object.keys(colorScheme).forEach((token) => {
    root.style.setProperty(`--${token}`, colorScheme[token as keyof ColorScheme]);
  });
};

export const getThemeColor = (tokenName: string): string | null => {
  if (typeof window !== 'undefined' && document.documentElement) {
    const cssToken = tokenName.startsWith('--') ? tokenName : `--${tokenName}`;
    const value = getComputedStyle(document.documentElement).getPropertyValue(cssToken).trim();
    return value || null;
  }
  return null;
};

const DNB_PARTNER_IDS = [
  'cc2f7c20-4c39-4272-b538-588361dee3e6',
  '8a4ea8ca-470f-4be7-a2ef-69508be415ec',
  '8b745cdb-03bf-4dad-a64d-0dd6638d0848',
];

const WYOMING_PARTNER_IDS = [
  'd75a1bc7-10a0-44dc-bd43-05b0e7bd7c13',
  '851b5217-872d-41a4-b6bf-a45a543e23b5',
];

const EIGHTEEN_HUNDRED_ACCOUNTANTS_PARTNER_IDS = [
  '1b91a55f-bfef-4a35-a1b7-cc5b5d972edd',
  '4ba67403-8e75-4a24-ba64-6a773082404c',
];

export const getColorSchemeByPartnerId = (partnerId: string): ColorScheme => {
  if (DNB_PARTNER_IDS.includes(partnerId)) {
    return dunAndBradstreetColorScheme;
  }
  if (WYOMING_PARTNER_IDS.includes(partnerId)) {
    return wyomingColorScheme;
  }
  if (EIGHTEEN_HUNDRED_ACCOUNTANTS_PARTNER_IDS.includes(partnerId)) {
    return eighteenHundredAccountantsColorScheme;
  }
  return liliColorScheme;
};
